/**
 * @author        patrick@zumper.com (Patrick Giddings)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   Debounce util
 */

type AnyFunc = (...args: any[]) => any

export const debounce = <Func extends AnyFunc>(
  fn: Func,
  wait: number,
  maxWait?: number
) => {
  let timeout: NodeJS.Timeout | null = null
  let lastRunAt: number | null = null
  const func = (...args: Parameters<typeof fn>) => {
    const callFn = () => {
      lastRunAt = Date.now()
      fn(...args)
    }
    if (timeout) {
      clearTimeout(timeout)
    }
    if (maxWait && lastRunAt && lastRunAt + maxWait <= Date.now()) {
      callFn()
    } else {
      timeout = setTimeout(callFn, wait)
    }
  }
  func.cancel = () => {
    if (timeout) {
      clearTimeout(timeout)
    }
  }
  return func
}
